export default [
  {
     path: '/searchGuide',
     name: 'search',
     component:() => import(/* webpackChunkName: "search" */'@/views/search/search-app.vue'),
     children:[
         {
             path:'',
             name:'searchSub',
             component:() => import(/* webpackChunkName: "searchSub" */'@/views/search/search-sub-menu.vue')
         }
      ]
  }
]